var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "highlightSection__chartBox" }, [
    _c("div", { staticClass: "highlightChart__wrapper" }, [
      _c(
        "div",
        { staticClass: "flex", class: { "flex--wrap": _vm.isMobile() } },
        [
          _c(
            "div",
            {
              staticClass: "panelCard highlightMapChart__container",
              class: { "opacity-0": _vm.loading },
            },
            [
              _c(
                "h5",
                {
                  staticClass:
                    "hl-module text-color--dark-blue-gray highlightMapChart__container--title",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.chartTitle) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._t("map"),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mapChartCountries__wrapper" }, [
            _c(
              "div",
              { staticClass: "mapChartCountries__wrapper--inner" },
              [
                _c(
                  "h5",
                  {
                    staticClass:
                      "hl-module margin-bottom-15 text-color--dark-blue-gray",
                    class: { "margin-top-15": _vm.isMobile() },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("XMO_HIGHLIGHTS_TOP_COUNTRIES")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.loading
                  ? _vm._l(3, function (index) {
                      return _c("CardPreloader", { key: index })
                    })
                  : _vm._l(_vm.getTopThreeCountries, function (country, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "panelCard flex mapChartCountries__wrapper--cards",
                        },
                        [
                          _c("div", { staticClass: "flex padding-all-10" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex--center flex--spaceBetween",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mapChartCountries__wrapper--imageWrapper",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.getCdnLink(
                                          `icons/flag/iso/svg_flags/${country.isoCode.toUpperCase()}.svg`
                                        ),
                                        alt: country.name,
                                        width: "30",
                                        height: "30",
                                        loading: "lazy",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "margin-left-5" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mapChartCountries__wrapper--country",
                                },
                                [_c("span", [_vm._v(_vm._s(country.name))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mapChartCountries__wrapper--revenue",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getRevenueForCountry(
                                          country.revenue
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        ref: "slider",
        staticClass:
          "highlightMapChart__container--mapSlider padding-horizontal-7 lineheight-16",
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }